module.exports = "/assets/data/4b992241d1b6fb8d232132f2d5184323-EX12.data.json";